import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="cta" className="relative w-full py-16 md:py-20 px-4 md:px-6 overflow-hidden" aria-labelledby="cta-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20with%20soft%20flowing%20lines%20in%20amber%20and%20gold%20tones%2C%20minimalist%20modern%20design%2C%20professional%20corporate%20atmosphere%2C%20clean%20elegant%20style&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 id="cta-heading" className="text-2xl md:text-3xl font-bold font-heading text-white mb-4">
          准备好升级你的人脉管理了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto">
          加入 10 万+ 职场精英，用好联系让每一次联系都更有价值。免费开始，无需绑定。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/#cta"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-base font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            免费开始使用
          </Link>
          <Link
            to="/about#contact"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-md text-base font-medium hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            联系销售团队
          </Link>
        </div>
      </div>
    </section>
  );
}